module.exports = __webpack_public_path__ + "static/media/vert.4b76f454.png";